export const TOGGLE_SIDEBAR  = 'TOGGLE_SIDEBAR ';
export const LOADING = "LOADING";
export const GET_ALL_EMPLOYEES = 'GET_ALL_EMPLOYEES'
export const GET_EMPLOYEE = 'GET_EMPLOYEE'
export const GET_EMPLOYEE_INFO = 'GET_EMPLOYEE_INFO'
export const SET_ADMIN_INFO = 'SET_ADMIN_INFO'

export const SET_LEAVES = 'SET_LEAVES'
export const LEAVE_REFRESH = 'LEAVE_REFRESH'

export const SET_REFRESH_PROJECT = 'SET_REFRESH_PROJECT'

export const CREATE_PROJECT = 'CREATE_PROJECT'
export const GET_PROJECTS = 'GET_PROJECTS'

export const SET_MANAGER_LIST = 'SET_MANAGER_LIST'

export const GET_ASSETS = 'GET_ASSETS'
export const SET_REFRESH_ASSET = 'SET_REFRESH_ASSET'
export const SET_ASSET_ENUMS = 'SET_ASSET_ENUMS'